<ng-container
  *ngIf="{
    selectedGroupIdentity: selectedGroupIdentity$ | async,
    applyTransitionClasses: applyTransitionClasses$ | async,
    requestsNeedingAttention: requestsNeedingAttention$ | async
  } as data"
>
  <ng-container *ngIf="(sortedClientRequestGroupsWithSelected$ | async)?.length; else zeroStateTemplate">
    <!-- Alert for requests needing attention -->
    @if (data.requestsNeedingAttention?.count > 0) {
      <div 
        class="alert alert--error requests-need-attention-alert"
        [dataSelector]="dataSelector + '-requests-need-attention-alert'"
      >
        <div class="mb-2">
          <strong>
            You have {{ data.requestsNeedingAttention.count }} 
            {{ data.requestsNeedingAttention.count === 1 ? 'request' : 'requests' }} 
            that need your attention
          </strong>
        </div>
        <div>
          <span>Projects: </span>
          @for (project of data.requestsNeedingAttention.projects; track project; let isLast = $last) {
            <span 
              class="clickable-project"
              (click)="scrollToProject(project)"
              [dataSelector]="dataSelector + '-clickable-project-' + project"
            >
              {{ project.groupName }}
            </span>@if (!isLast) {<span>, </span>}
          }
        </div>
      </div>
    }
    <app-client-request-group
      *ngFor="let group of sortedClientRequestGroupsWithSelected$ | async; trackBy: trackClientRequestGroups"
      [instance]="group"
      [isSelected]="data.selectedGroupIdentity === group.identity"
      class="cxp-transition cxp-height-transition"
      [ngClass]="{
        'selected-client-request-group': data.selectedGroupIdentity === group.identity,
        'h-100 mb-15': data.applyTransitionClasses && data.selectedGroupIdentity === group.identity,
        'cxp-shrink-height cxp-fade-out': data.applyTransitionClasses && data.selectedGroupIdentity && data.selectedGroupIdentity !== group.identity
      }"
      [attr.aria-hidden]="data.applyTransitionClasses && data.selectedGroupIdentity && data.selectedGroupIdentity !== group.identity"
      [dataSelector]="dataSelector + '-group-' + group.identity"
    ></app-client-request-group>
  </ng-container>

  <ng-template #zeroStateTemplate>
    <div
      *ngIf="{ value: areFiltersSelected$ | async } as areFiltersSelected"
      class="d-flex flex-column align-items-center justify-content-center h-100 px-15"
      [dataSelector]="dataSelector + '-zero-state'"
    >
      <h1
        class="h2-800 color-gray-100"
        [dataSelector]="dataSelector + '-zero-state-title'"
      >
        No projects {{ areFiltersSelected.value ? 'found' : 'available' }}
      </h1>

      <p
        class="body-400 text-center mt-4"
        [dataSelector]="dataSelector + '-zero-state-description'"
      >
        {{
          areFiltersSelected.value
            ? 'There aren\'t any projects that match this combination of filters. Please try removing or changing your filters selection.'
            : 'If any projects are shared with you, they\'ll appear here.'
        }}
      </p>
    </div>
  </ng-template>
</ng-container>

<mat-spinner 
  *ngIf="showSpinner$ | async" 
  [diameter]="24"
  [dataSelector]="dataSelector + '-loading-spinner'"
></mat-spinner>
